import '@i18n';
import GTManager from './gtm';
import { init as initAppHeight } from './app-height';
import { init as initChartJS } from './chartjs';
import FacebookSDK from './facebook';
import { init as initGoogleMap } from './init-google-map';
import './yup-config';

const initWidgets = () => {
    initAppHeight();
    GTManager.init();
    FacebookSDK.init();
    initChartJS();
    initGoogleMap();
};

export default initWidgets;
